import {
    GenericItemsUtils,
    IGetAllParams,
    GenericItemsForm,
    BaseGenericItemsStore,
    Grid,
    MuiDataGrid,
    MuiIcons,
    Toc as TocIcon
} from "@leap4/frontend";

import {DataPointStatus, IDataPoint} from "@leap4/entities-discrepancy-common"
import {dataPointsUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService"
import {connect, ConnectedProps} from "react-redux";
import {RootState} from "../../../interfaces/root-state.interface";
import {Server} from "@leap4/auth";
import React from "react";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);


type PropsFromRedux = ConnectedProps<typeof connector>;

const fields = {
    name: 1,
    type: 1,
    adServer: 1,
    // partner: 1,
    status: 1,
    updated: 1,
    isActive: 1,
    overview: 1
}

const getParams: IGetAllParams = {
    fields,
    populate: [
        {path: "adServer", select: {name: 1}},
        // {path: "partner", select: {name: 1}}
    ]
}

function renderStatus(params: GridRenderCellParams) {
    const status = params.value;
    let color;

    switch (status) {
        case DataPointStatus.ACTIVE:
            color = "green";
            break
        case DataPointStatus.PENDING:
            color = "yellow";
            break;

        case DataPointStatus.INACTIVE:
            color = 'red';
            break;

        default:
            throw new Error("Invalid status")
    }

    return <strong style={{color, textTransform: "capitalize"}}>{status}</strong>;
}

function renderAdServerCell(params: GridRenderCellParams) {
    const obj = params.value as any;
    return obj.name;
}


let columns: GridColDef[];
let store: BaseGenericItemsStore<IDataPoint & { _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: dataPointsUrl,
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editDataPoint(id)},
        isActive: {},
        updated: {},
        created: {},
        // overview: {overviewLinkFunc: (id: string) => urlService.dataPointOverview(id)}
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
    // TODO: Add error handling, and extract to function.
    columns.find(x => x.field === "status").renderCell = renderStatus;
    // columns.find(col => col.field === "partner")!.renderCell = renderPartnerCell;
    columns.find(col => col.field === "adServer")!.renderCell = renderAdServerCell;
}


const DataPointsModule = (props:PropsFromRedux) => {
    setStoreAndColumns();
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.dataPoints(),
                text: "Data Points Dashboard",
                icon: <TocIcon />
            }}
            organization={props.selectedOrganization}
            getAllParams={getParams}
            tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
            createButton={{
                to: urlService.createDataPoint(),
                text: "create data point ".toUpperCase()
            }}/>
    );
};


export default connector(DataPointsModule);